module.exports = __webpack_public_path__ + "img/bannner.2cd9d2f1.png";